module.exports = __webpack_public_path__ + "static/img/16-深圳实验.01ef16e9.png";